export enum EnergyMeterConnectedDeviceType {
    PV = "pv",
    SUPPLY = "supply",
    CHARGING_PARK = "chargingPark",
    BATTERY = "battery",
    BUILDING = "building",
}